import { React, useState } from "react";
import SideBar from "components/SideBar/SideBar";
import CollapseIcon from "../../assets/images/sidebar_collapse_arrow.svg";
import CampaignSetup from "../../components/Campaigns/CampaignSetup/CampaignSetup";
// import BannerNotification from 'components/BannerNotification/BannerNotification';

function CampaignSetupContainer() {
    
    const [isActive, setActive] = useState("false");

    const handleToggle = () => {
        setActive(!isActive);
    };

    return (
        <div className="sidebar_main_wrapper">
            <div className={isActive ? "sidebar sidebar-collapse" : "sidebar"}>
                <button
                    onClick={handleToggle}
                    className={isActive ? "collapse-icon rotate-icon" : "collapse-icon"}
                >
                    <img src={CollapseIcon} alt="icon" />
                </button>
                <SideBar />
            </div>
            <div
                className={
                    isActive
                        ? "right-container right-container-collapse campaign-container"
                        : "right-container campaign-container"
                }
            >
                {/* <BannerNotification /> */}
                <div className="right-inner-container">
                    <CampaignSetup />
                </div>
            </div>
        </div>
    );
}

export default CampaignSetupContainer;
